import React, { useState } from "react";
import { FaBuilding, FaPersonBooth } from "react-icons/fa";
import Input from "../../../../../../../components/Input";
import Popup from "../../../../../../../components/Popup";
import collaboratorServices from "../../../../../../../services/admFin/collaboratorServices";


export function NewPaymentPopUp(props) {
    const [dataReferente, setDataReferente] = useState("");
    const [valorPago, setValorPago] = useState("");

    async function onPayment(e) {
        if (!dataReferente || !valorPago) {
            alert("Os campos devem estar preenchidos");
            return;
        }
        console.log(new Date().toISOString().split("T")[0]);
        try {
            await collaboratorServices.postPayment(
                props.id,
                new Date().toISOString().split("T")[0],
                dataReferente,
                valorPago
            );
            props.getPayments();
            props.setVisibility(false);
        } catch (err) {
            alert("Não foi possível realizar o pagamento");
        }
    }
    return (
        <Popup
            visibility={props.visibility}
            setVisibility={props.setVisibility}
            tittle={"Novo Pagamento"}
            icon={<FaPersonBooth />}
        >
            <div className="records-element-info">
                <Input
                    label="Data Referente*"
                    type="date"
                    placeholder="Digite a data referente ao pagamento"
                    id="collaborator-payment-popup-date"
                    onChange={(e) => setDataReferente(e.target.value)}
                    value={dataReferente}
                />  
                <Input
                    label="Valor Pago*"
                    type="currency"
                    placeholder="Valor pago ao colaborador"
                    id="collaborator-payment-popup-paid-value"
                    onChange={(e) => setValorPago(e.target.value)}
                    value={valorPago}
                /> 

                <button onClick={onPayment}>Realizar Pagamento</button>          
            </div>
        </Popup>
    )
}